/*
  Lookbook rows (sections/section-lookbook.liquid). ONE value per row, data-open = "" | "a" | "b";
  everything on screen is derived from it by CSS. Opening the other card of a pair is one
  assignment and one transition (CSS retargets mid-flight), never a close then an open.
  Desktop (1025+): the card opens its drawer, only the X closes it, focus goes to the X on
  open and back to the card on close, Escape closes. Below 1025 the card opens a native
  dialog sheet with a copy of the drawer. Nothing is measured: the track widths are CSS.
  Without this script every card stays a link to its product.
*/
(function () {
  var wide = window.matchMedia('(min-width: 1025px)');

  function setup(root) {
    if (root.dataset.lbReady) return;
    root.dataset.lbReady = '1';
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-lb-row]'));
    var sheet = root.querySelector('[data-lb-sheet]');
    var sheetBody = root.querySelector('[data-lb-sheet-body]');
    var sheetOpener = null;

    function parts(row, side) {
      var cell = row.querySelector('.lookbook__cell--' + side);
      if (!cell) return null;
      var card = cell.querySelector('[data-lb-card]');
      return { card: card, close: cell.querySelector('[data-lb-close]'), drawer: document.getElementById(card.getAttribute('aria-controls')) };
    }

    function set(row, side, focus) {
      var was = row.dataset.open || '';
      if (was === side) return;
      row.dataset.open = side;
      row.classList.add('is-moving');
      ['a', 'b'].forEach(function (s) {
        var p = parts(row, s);
        if (!p) return;
        var open = s === side;
        p.card.setAttribute('aria-expanded', open ? 'true' : 'false');
        p.card.tabIndex = open ? -1 : 0;
        if (open) p.card.setAttribute('aria-hidden', 'true'); else p.card.removeAttribute('aria-hidden');
        p.close.tabIndex = open ? 0 : -1;
        if (p.drawer) {
          p.drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
          p.drawer.inert = !open;
        }
      });
      if (!focus) return;
      if (side) parts(row, side).close.focus({ preventScroll: true });
      else if (was) parts(row, was).card.focus({ preventScroll: true });
    }

    function openSheet(card) {
      var drawer = document.getElementById(card.getAttribute('aria-controls'));
      if (!sheet || !drawer || typeof sheet.showModal !== 'function') { window.location.href = card.href; return; }
      var copy = drawer.cloneNode(true);
      copy.removeAttribute('id');
      copy.removeAttribute('aria-hidden');
      copy.inert = false;
      copy.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      sheetBody.replaceChildren(copy);
      sheetOpener = card;
      // The dialog hands focus back to whatever had it before showModal, after our close
      // handler runs; make that the card, so a tap (which may not focus it) still returns there.
      card.focus({ preventScroll: true });
      sheet.showModal();
      sheet.querySelector('[data-lb-sheet-close]').focus();
    }

    if (sheet) {
      sheet.addEventListener('click', function (e) {
        if (e.target === sheet || e.target.closest('[data-lb-sheet-close]')) sheet.close();
      });
      sheet.addEventListener('close', function () {
        var opener = sheetOpener;
        sheetOpener = null;
        if (opener) requestAnimationFrame(function () { opener.focus({ preventScroll: true }); });
      });
    }

    // Decode a row's photographs and packshots before any card in it can open, so the
    // slide never reveals an undecoded image.
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        entry.target.querySelectorAll('img').forEach(function (img) {
          if (img.loading === 'lazy') img.loading = 'eager';
          if (img.decode) img.decode().catch(function () {});
        });
      });
    }, { rootMargin: '600px 0px' }) : null;

    rows.forEach(function (row) {
      row.dataset.open = '';
      ['a', 'b'].forEach(function (s) {
        var p = parts(row, s);
        if (!p) return;
        p.card.setAttribute('role', 'button');
        p.card.setAttribute('aria-expanded', 'false');
        p.card.setAttribute('aria-label', p.card.dataset.lbOpenLabel);
        p.card.addEventListener('click', function (e) {
          e.preventDefault();
          if (wide.matches) set(row, s, true);
          else openSheet(p.card);
        });
        p.card.addEventListener('keydown', function (e) {
          if (e.key === ' ') { e.preventDefault(); p.card.click(); }
        });
        p.close.addEventListener('click', function () { set(row, '', true); });
      });
      row.addEventListener('pointerenter', function () { row.classList.add('is-moving'); });
      row.querySelector('[data-lb-track]').addEventListener('transitionend', function (e) {
        if (e.propertyName === 'transform') row.classList.remove('is-moving');
      });
      if (io) io.observe(row);
    });

    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !wide.matches) return;
      var row = e.target.closest('[data-lb-row]');
      if (row && row.dataset.open) { e.preventDefault(); set(row, '', true); }
    });

    // Crossing 1025 with something open: the drawer and the sheet must not both think so.
    wide.addEventListener('change', function () {
      rows.forEach(function (row) { set(row, '', false); });
      if (sheet && sheet.open) sheet.close();
    });

    // Furniture categories: one group of rows per category, the chips show one group. ?c=<category id> (from a category
    // page's "See the full lookbook") opens on it; an unknown key falls back to All. The URL follows the chip.
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-lb-group]'));
    var cats = Array.prototype.slice.call(root.querySelectorAll('[data-lb-cat]'));
    function show(key) {
      if (!groups.some(function (g) { return g.dataset.lbGroup === key; })) key = '';
      rows.forEach(function (row) { set(row, '', false); });
      groups.forEach(function (g) { g.hidden = g.dataset.lbGroup !== key; });
      cats.forEach(function (c) { c.setAttribute('aria-pressed', String(c.dataset.lbCat === key)); });
      var u = new URL(location.href);
      if (key) u.searchParams.set('c', key); else u.searchParams.delete('c');
      history.replaceState(history.state, '', u);
    }
    cats.forEach(function (c) { c.addEventListener('click', function () { show(c.dataset.lbCat); }); });
    var start = new URL(location.href).searchParams.get('c');
    if (start) show(start);
  }

  function init() { document.querySelectorAll('[data-lookbook]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
